import PropTypes from "prop-types";
import { useState } from "react";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  Box,
  Typography,
  Paper,
  Divider,
} from "@mui/material";

function RadioButtonGroupField({ displayName, fieldRef, options }) {
  const [value, setValue] = useState(null);

  return (
    <Box>
      <Box mb={1}>
        <Typography variant="subtitle2" fontWeight={400}>
          {displayName}
        </Typography>
      </Box>
      <Box mb={1}>
        <Divider />
      </Box>

      <RadioGroup value={value} onChange={(e) => setValue(e.target.value)}>
        {options?.map((opt) => (
          <FormControlLabel
            key={opt.value}
            value={opt.value}
            control={<Radio />}
            label={opt.name}
          />
        ))}
      </RadioGroup>

      <input
        type="hidden"
        id={`dff_${fieldRef}`}
        name={fieldRef}
        value={value}
      />
    </Box>
  );
}

// Typechecking props
RadioButtonGroupField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
};

RadioButtonGroupField.defaultProps = {
  options: [],
};

export default RadioButtonGroupField;
